import { render } from "./CandidateStatusDropdown.vue?vue&type=template&id=b2657cf2"
import script from "./CandidateStatusDropdown.vue?vue&type=script&lang=js"
export * from "./CandidateStatusDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__